var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d_30064_2850)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.802 46.0001C95.802 71.2958 75.2958 91.802 50.0001 91.802C24.7044 91.802 4.19824 71.2958 4.19824 46.0001C4.19824 20.7044 24.7044 0.198242 50.0001 0.198242C75.2958 0.198242 95.802 20.7044 95.802 46.0001Z",
  fill: "url(#paint0_radial_30064_2850)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.802 46.0001C95.802 71.2958 75.2958 91.802 50.0001 91.802C24.7044 91.802 4.19824 71.2958 4.19824 46.0001C4.19824 20.7044 24.7044 0.198242 50.0001 0.198242C75.2958 0.198242 95.802 20.7044 95.802 46.0001Z",
  fill: "url(#paint1_radial_30064_2850)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8511 65.8796C30.8511 62.7578 36.5958 60.0426 36.5958 60.0426C36.5958 60.0426 42.1491 56.8511 50 56.8511C57.8509 56.8511 63.4159 60.2272 63.4159 60.2272C63.4159 60.2272 69.1489 62.7578 69.1489 65.8796C69.1489 69.0013 66.5822 71.5319 63.4159 71.5319C63.4159 71.5319 55.277 67.0638 50 67.0638C44.7235 67.0639 36.5841 71.5319 36.5841 71.5319C33.4178 71.5319 30.8511 69.0013 30.8511 65.8796Z",
  fill: "#7F2F17"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_ddii_30064_2850)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.8065 27.4207C24.0576 26.4161 25.0756 25.8053 26.0802 26.0564L41.0802 29.8064C41.8992 30.0112 42.4804 30.7379 42.5 31.5819C42.5196 32.4258 41.9728 33.1788 41.1643 33.4214L22.4143 39.0464C21.4224 39.3439 20.3771 38.7811 20.0796 37.7892C19.782 36.7974 20.3449 35.7521 21.3367 35.4545L33.5523 31.7898L25.1707 29.6945C24.1661 29.4433 23.5553 28.4253 23.8065 27.4207Z",
  fill: "#894819"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_dii_30064_2850)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.1945 27.4207C75.9434 26.4161 74.9254 25.8053 73.9207 26.0564L58.9208 29.8064C58.1018 30.0112 57.5206 30.7379 57.501 31.5819C57.4814 32.4258 58.0282 33.1788 58.8367 33.4214L77.5867 39.0464C78.5786 39.3439 79.6238 38.7811 79.9214 37.7892C80.219 36.7974 79.6561 35.7521 78.6643 35.4545L66.4487 31.7898L74.8302 29.6945C75.8349 29.4433 76.4457 28.4253 76.1945 27.4207Z",
  fill: "#894819"
})));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_30064_2850",
  x: 0.198242,
  y: 0.198242,
  width: 99.6035,
  height: 99.6038,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_30064_2850",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_ddii_30064_2850",
  x: 14,
  y: 20,
  width: 40.5005,
  height: 31.126,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0727691 0 0 0 0 0.00493009 0 0 0 0 0.216927 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0119274 0 0 0 0 0.0199607 0 0 0 0 0.21276 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_30064_2850",
  result: "effect2_dropShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_30064_2850",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 6,
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.76276 0 0 0 0 0.388636 0 0 0 0 0.122215 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -6,
  dy: -6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.354427 0 0 0 0 0.180009 0 0 0 0 0.0538352 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_innerShadow_30064_2850",
  result: "effect4_innerShadow_30064_2850"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_dii_30064_2850",
  x: 51.5005,
  y: 20,
  width: 40.5005,
  height: 31.126,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.075147 0 0 0 0 0.00953788 0 0 0 0 0.15865 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_30064_2850",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 6,
  dy: 6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.76276 0 0 0 0 0.388636 0 0 0 0 0.122215 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_30064_2850"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -6,
  dy: -6
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.354427 0 0 0 0 0.180009 0 0 0 0 0.0538352 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_30064_2850",
  result: "effect3_innerShadow_30064_2850"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_30064_2850",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(69.9028 79.432) rotate(-121.418) scale(84.0718 87.4905)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9D41"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD75C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_30064_2850",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(33.4999 22.5303) rotate(58.815) scale(62.7947 53.5861)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEFA5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE25E",
  stopOpacity: 0
})));

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoutIcon.323e7432.svg";
export { ForwardRef as ReactComponent };